export class EnaioVariantInfo {
    id = 0;
    parentId = 0;
    version: string;
    isActive = false;
}
